var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerGameTypeGbp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3a9 9 0 110 18 9 9 0 010-18zm.666 3.44c-.64 0-1.206.126-1.699.38-.493.254-.881.62-1.164 1.099-.279.474-.418 1.047-.418 1.721l.06 1.787H8.28v1.428h1.213l.047 1.392c0 .2-.017.415-.051.645-.03.224-.088.422-.176.593a.544.544 0 01-.366.308h-.637v1.457h7.668l-.007-1.457h-5.06a1.75 1.75 0 00.218-.352c.176-.371.262-.791.257-1.26l-.05-1.325h2.254v-1.429h-2.307l-.066-1.787c0-.38.061-.7.183-.96.123-.258.289-.453.499-.585.214-.132.454-.198.717-.198.259 0 .498.049.718.146.225.098.405.257.542.477.137.214.205.505.205.871h1.772c0-.586-.124-1.099-.373-1.538a2.592 2.592 0 00-1.084-1.04c-.474-.249-1.05-.374-1.729-.374z",
    fill: "currentColor"
  })));
}
SvgPokerGameTypeGbp.displayName = 'PokerGameTypeGbp';
export default SvgPokerGameTypeGbp;